import type {
  EqualizeBoostingField,
  EqualizeFunctionField,
  EqualizeSearchableField,
} from '../modules/equalize'
// @ts-strict-ignore
import { EqualizeBoostingActionEnum } from '../enums/equalize-boosting-action.enum'

export const getSearchableFieldPreviewParams = (
  searchableFieldsConfig: Array<EqualizeSearchableField>,
): { equalize: string } => {
  const params = {}

  searchableFieldsConfig.forEach(field => {
    params[field.name] = field.boost
  })

  return {
    equalize: JSON.stringify(params),
  }
}

export const getBoostingPreviewParams = (
  boostsFieldsConfig: Array<EqualizeBoostingField>,
): { businessRulesBoosts: string; businessRulesBuries: string } => {
  const params = {
    [EqualizeBoostingActionEnum.BOOST]: [],
    [EqualizeBoostingActionEnum.BURY]: [],
  }

  boostsFieldsConfig.forEach(({ action, field, value, boostFactor }) => {
    params[action].push({ field, value, boostFactor })
  })

  const paramToString = ({ field, value, boostFactor }: EqualizeBoostingField): string =>
    `${field}:${value}^${boostFactor}`

  return {
    businessRulesBoosts: params[EqualizeBoostingActionEnum.BOOST].map(paramToString).join(),
    businessRulesBuries: params[EqualizeBoostingActionEnum.BURY].map(paramToString).join(),
  }
}

export const getFunctionScorePreviewParams = (
  functionScoreConfig: Array<EqualizeFunctionField>,
): Record<string, any> => {
  const params = {
    'fs.fields': [],
  }

  functionScoreConfig.forEach(({ boostFactor, fieldName, formulaType, weight }) => {
    params['fs.fields'].push(fieldName)
    params[`fs.${fieldName}.boostFactor`] = boostFactor
    params[`fs.${fieldName}.formulaType`] = formulaType
    params[`fs.${fieldName}.weight`] = weight
  })

  return {
    ...params,
    'fs.fields': params['fs.fields'].join(','),
  }
}
